import {
    mdiArrowLeft,
    mdiArrowDownBoldBox,
    mdiArrowUpBoldBox,
    mdiAccount,
    mdiAccountBox,
    mdiAccountCancel,
    mdiAlert,
    mdiAccountCheck,
    mdiAccountCircle,
    mdiThumbsUpDown,
    mdiAccountGroup,
    mdiAccountGroupOutline,
    mdiArrowCollapseAll,
    mdiArrowCollapse,
    mdiAccountLock,
    mdiChatProcessing,
    mdiAccountEye,
    mdiTrafficLight,
    mdiCursorDefaultClick,
    mdiRocketLaunch,
    mdiFinance,
    mdiAt,
    mdiTableSearch,
    mdiMessageDraw,
    mdiMapMarker,
    mdiFactory,
    mdiRuler,
    mdiFileDocumentRemove,
    mdiGasStation,
    mdiExcavator,
    mdiHammerWrench,
    mdiTruckDelivery,
    mdiPhone,
    mdiStar,
    mdiVote,
    mdiCrowd,
    mdiPlay,
    mdiMultimedia,
    mdiRecycle,
    mdiAccountSwitch,
    mdiEmailHeartOutline,
    mdiAccountOutline,
    mdiAccountPlus,
    mdiAdvertisements,
    mdiApps,
    mdiPencil,
    mdiPencilOutline,
    mdiTrashCan,
    mdiSync,
    mdiTablePlus,
    mdiTrashCanOutline,
    mdiClipboardTextClock,
    mdiClipboardTextClockOutline,
    mdiCash,
    mdiCashMultiple,
    mdiFileArrowLeftRight,
    mdiFileArrowLeftRightOutline,
    mdiAppsBox,
    mdiApi,
    mdiApple,
    mdiAppleKeyboardCommand,
    mdiAppleSafari,
    mdiArrowDownCircleOutline,
    mdiArrowTopRight,
    mdiArrowULeftTop,
    mdiArrowUpCircleOutline,
    mdiBell,
    mdiBellOutline,
    mdiBellRing,
    mdiCancel,
    mdiCartPlus,
    mdiChatQuestion,
    mdiCheckBold,
    mdiCheck,
    mdiCheckCircle,
    mdiChevronLeft,
    mdiArrowCollapseLeft,
    mdiChevronRight,
    mdiReceiptClockOutline,
    mdiReceiptClock,
    mdiTicketConfirmationOutline,
    mdiReceiptTextClockOutline,
    mdiReceiptTextSend,
    mdiListBox,
    mdiListBoxOutline,
    mdiReceiptTextSendOutline,
    mdiArrowCollapseRight,
    mdiChevronDown,
    mdiChevronUp,
    mdiClockOutline,
    mdiClose,
    mdiCodeJson,
    mdiCog,
    mdiComment,
    mdiContentCopy,
    mdiCookie,
    mdiChartAreaspline,
    mdiCurrencyUsd,
    mdiCrown,
    mdiCpu64Bit,
    mdiCreditCard,
    mdiCreditCardOutline,
    mdiDatabase,
    mdiDesktopTowerMonitor,
    mdiDns,
    mdiDotsVertical,
    mdiEarth,
    mdiEmail,
    mdiEmailOpen,
    mdiEmailFast,
    mdiEthernet,
    mdiEthernetCable,
    mdiEye,
    mdiEyeOff,
    mdiFilterVariant,
    mdiFirefox,
    mdiFrequentlyAskedQuestions,
    mdiFormatListBulletedType,
    mdiGamepadSquare,
    mdiGoogle,
    mdiGoogleChrome,
    mdiHdmiPort,
    mdiHomeOutline,
    mdiHelp,
    mdiImage,
    mdiImageArea,
    mdiImageRemove,
    mdiImageRemoveOutline,
    mdiInformation,
    mdiInformationOutline,
    mdiInvoiceList,
    mdiIp,
    mdiLinkVariant,
    mdiLinkedin,
    mdiLinux,
    mdiHeartMultiple,
    mdiMenuRight,
    mdiLock,
    mdiLogin,
    mdiLoginVariant,
    mdiLogout,
    mdiMagnify,
    mdiMapMarkerPath,
    mdiMemory,
    mdiMicrosoftEdge,
    mdiMicrosoftWindows,
    mdiMonitorDashboard,
    mdiMoonWaxingCrescent,
    mdiNas,
    mdiHelpNetworkOutline,
    mdiPalette,
    mdiPlus,
    mdiPlusBox,
    mdiPlusBoxOutline,
    mdiPower,
    mdiPowerCycle,
    mdiSendVariant,
    mdiReceiptText,
    mdiReceiptTextOutline,
    mdiReceiptTextClock,
    mdiSitemap,
    mdiShare,
    mdiShareAll,
    mdiShieldHome,
    mdiShieldLock,
    mdiSwapHorizontal,
    mdiTabletCellphone,
    mdiThumbUp,
    mdiThemeLightDark,
    mdiTicketConfirmation,
    mdiTranslate,
    mdiTimerSync,
    mdiTune,
    mdiTwitter,
    mdiUpdate,
    mdiViewDashboard,
    mdiViewDashboardOutline,
    mdiAccountMultiplePlus,
    mdiMessageText,
    mdiAccountMultiplePlusOutline,
    mdiWallet,
    mdiWeatherNight,
    mdiWeatherSunny,
    mdiWeb,
    mdiWebBox,
    mdiWhiteBalanceSunny,
    mdiWifi,
    mdiHome,
    mdiSpade,
    mdiDumpTruck,
    mdiHandSaw,
    mdiShapePlus,
    mdiAccountHardHat
} from '@mdi/js';

// Export only the needed icons
export default {
    mdiArrowLeft,
    mdiArrowDownBoldBox,
    mdiArrowUpBoldBox,
    mdiAccount,
    mdiAccountBox,
    mdiAccountCancel,
    mdiAccountCheck,
    mdiAccountCircle,
    mdiThumbsUpDown,
    mdiAccountGroup,
    mdiAccountGroupOutline,
    mdiArrowCollapseAll,
    mdiArrowCollapse,
    mdiAccountLock,
    mdiChatProcessing,
    mdiAccountEye,
    mdiTrafficLight,
    mdiCursorDefaultClick,
    mdiRocketLaunch,
    mdiFinance,
    mdiAt,
    mdiTableSearch,
    mdiMessageDraw,
    mdiMapMarker,
    mdiFactory,
    mdiRuler,
    mdiFileDocumentRemove,
    mdiGasStation,
    mdiExcavator,
    mdiHammerWrench,
    mdiAccountHardHat,
    mdiTruckDelivery,
    mdiPhone,
    mdiStar,
    mdiVote,
    mdiCrowd,
    mdiPlay,
    mdiMultimedia,
    mdiRecycle,
    mdiAccountSwitch,
    mdiEmailHeartOutline,
    mdiAccountOutline,
    mdiAccountPlus,
    mdiAdvertisements,
    mdiAlert,
    mdiApps,
    mdiPencil,
    mdiPencilOutline,
    mdiTrashCan,
    mdiSync,
    mdiTablePlus,
    mdiTrashCanOutline,
    mdiClipboardTextClock,
    mdiClipboardTextClockOutline,
    mdiCash,
    mdiCashMultiple,
    mdiFileArrowLeftRight,
    mdiFileArrowLeftRightOutline,
    mdiAppsBox,
    mdiApi,
    mdiApple,
    mdiAppleKeyboardCommand,
    mdiAppleSafari,
    mdiArrowDownCircleOutline,
    mdiArrowTopRight,
    mdiArrowULeftTop,
    mdiArrowUpCircleOutline,
    mdiBell,
    mdiBellOutline,
    mdiBellRing,
    mdiCancel,
    mdiCartPlus,
    mdiChatQuestion,
    mdiCheck,
    mdiCheckCircle,
    mdiChevronLeft,
    mdiArrowCollapseLeft,
    mdiChevronRight,
    mdiReceiptClockOutline,
    mdiReceiptClock,
    mdiTicketConfirmationOutline,
    mdiReceiptTextClockOutline,
    mdiReceiptTextSend,
    mdiListBox,
    mdiListBoxOutline,
    mdiReceiptTextSendOutline,
    mdiArrowCollapseRight,
    mdiChevronDown,
    mdiChevronUp,
    mdiClockOutline,
    mdiClose,
    mdiCodeJson,
    mdiCog,
    mdiComment,
    mdiContentCopy,
    mdiCookie,
    mdiChartAreaspline,
    mdiCurrencyUsd,
    mdiCrown,
    mdiCpu64Bit,
    mdiCreditCard,
    mdiCreditCardOutline,
    mdiDatabase,
    mdiDesktopTowerMonitor,
    mdiDns,
    mdiDotsVertical,
    mdiEarth,
    mdiEmail,
    mdiEmailOpen,
    mdiEmailFast,
    mdiEthernet,
    mdiEthernetCable,
    mdiEye,
    mdiEyeOff,
    mdiFilterVariant,
    mdiFirefox,
    mdiFrequentlyAskedQuestions,
    mdiFormatListBulletedType,
    mdiGamepadSquare,
    mdiGoogle,
    mdiGoogleChrome,
    mdiCheckBold,
    mdiHdmiPort,
    mdiHomeOutline,
    mdiHelp,
    mdiImage,
    mdiImageArea,
    mdiImageRemove,
    mdiImageRemoveOutline,
    mdiInformation,
    mdiInformationOutline,
    mdiInvoiceList,
    mdiIp,
    mdiLinkVariant,
    mdiLinkedin,
    mdiLinux,
    mdiHeartMultiple,
    mdiMenuRight,
    mdiLock,
    mdiLogin,
    mdiLoginVariant,
    mdiLogout,
    mdiMagnify,
    mdiMapMarkerPath,
    mdiMemory,
    mdiMicrosoftEdge,
    mdiMicrosoftWindows,
    mdiMonitorDashboard,
    mdiMoonWaxingCrescent,
    mdiNas,
    mdiHelpNetworkOutline,
    mdiPalette,
    mdiPlus,
    mdiPlusBox,
    mdiPlusBoxOutline,
    mdiPower,
    mdiPowerCycle,
    mdiSendVariant,
    mdiReceiptText,
    mdiReceiptTextOutline,
    mdiReceiptTextClock,
    mdiSitemap,
    mdiShare,
    mdiShareAll,
    mdiShieldHome,
    mdiShieldLock,
    mdiSwapHorizontal,
    mdiTabletCellphone,
    mdiThumbUp,
    mdiThemeLightDark,
    mdiTicketConfirmation,
    mdiTranslate,
    mdiTimerSync,
    mdiTune,
    mdiTwitter,
    mdiUpdate,
    mdiViewDashboard,
    mdiViewDashboardOutline,
    mdiAccountMultiplePlus,
    mdiMessageText,
    mdiAccountMultiplePlusOutline,
    mdiWallet,
    mdiWeatherNight,
    mdiWeatherSunny,
    mdiWeb,
    mdiWebBox,
    mdiWhiteBalanceSunny,
    mdiWifi,
    mdiHome,
    mdiSpade,
    mdiDumpTruck,
    mdiHandSaw,
    mdiShapePlus
}